/**
 * Zentrales Logging-Utility
 *
 * Policy:
 * - logError/logWarn: Immer sichtbar (Fehler/echte Probleme bleiben sichtbar)
 * - logDebug/logInfo: Nur in DEV oder wenn VITE_DEBUG_LOGS=true gesetzt ist
 *
 * Usage:
 *   import { logDebug, logInfo, logWarn, logError } from '@/lib/logger';
 *   logDebug('MyComponent/action', 'message', data);
 *
 * Production Debugging:
 *   Setze VITE_DEBUG_LOGS=true in .env um alle Debug-Logs zu sehen
 */

const isDev = import.meta.env.DEV;
const ENABLE_DEBUG_LOGS = import.meta.env.VITE_DEBUG_LOGS === "true";

/**
 * Debug-Logs: Nur in DEV oder wenn VITE_DEBUG_LOGS=true
 * Für detaillierte Entwicklungs-Informationen
 */
export function logDebug(ns: string, ...args: unknown[]): void {
  if (!isDev && !ENABLE_DEBUG_LOGS) return;
  console.debug(`[${ns}]`, ...args);
}

/**
 * Info-Logs: Nur in DEV oder wenn VITE_DEBUG_LOGS=true
 * Für wichtige, aber nicht kritische Informationen
 */
export function logInfo(ns: string, ...args: unknown[]): void {
  if (!isDev && !ENABLE_DEBUG_LOGS) return;
  console.info(`[${ns}]`, ...args);
}

/**
 * Warn-Logs: Immer sichtbar
 * Für Warnungen, die Aufmerksamkeit erfordern
 */
export function logWarn(ns: string, ...args: unknown[]): void {
  console.warn(`[${ns}]`, ...args);
}

/**
 * Error-Logs: Immer sichtbar
 * Für Fehler, die immer geloggt werden müssen
 */
export function logError(ns: string, ...args: unknown[]): void {
  console.error(`[${ns}]`, ...args);
}
